import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import { TopicInfosEmptyGuard, WidgetLoadingGuard } from '../share/guards'
import RunSearchEffect from './RunSearchEffect'
import BrandPassionIndexWidgetDataGuards from './guards/BrandPassionIndexWidgetDataGuards'
import BrandPassionIndex from './BrandPassionIndex'

interface SocialWebBrandPassionIndexWidgetProps {
  widgetId: number
}

const SocialWebBrandPassionIndexWidget = ({ widgetId }: SocialWebBrandPassionIndexWidgetProps) => (
  <UnexpectedErrorBoundary>
    <TopicInfosEmptyGuard widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId}>
        <WidgetLoadingGuard widgetId={widgetId}>
          <BrandPassionIndexWidgetDataGuards widgetId={widgetId}>
            <BrandPassionIndex widgetId={widgetId} />
          </BrandPassionIndexWidgetDataGuards>
        </WidgetLoadingGuard>
      </RunSearchEffect>
    </TopicInfosEmptyGuard>
  </UnexpectedErrorBoundary>
)

export default SocialWebBrandPassionIndexWidget
